import React from "react";

const TodoFilters = ({ todoFilter, setTodoFilter, todoStats, t, theme, screenSize }) => {
  const filters = [
    { key: "all", label: t.allTasks, count: todoStats.total },
    { key: "active", label: t.activeTasks, count: todoStats.total - todoStats.completed },
    { key: "completed", label: t.completedTasks, count: todoStats.completed },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: screenSize.isMobile ? 8 : 10,
      }}
    >
      {filters.map((f) => (
        <button
          key={f.key}
          onClick={() => setTodoFilter(f.key)}
          style={{
            padding: screenSize.isMobile ? "10px 8px" : "12px 10px",
            fontSize: screenSize.isMobile ? 12 : 13,
            fontWeight: 700,
            color:
              todoFilter === f.key
                ? "#fff"
                : theme === "dark"
                ? "rgba(255,255,255,0.7)"
                : "rgba(0,0,0,0.7)",
            background:
              todoFilter === f.key
                ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
                : theme === "dark"
                ? "rgba(255,255,255,0.05)"
                : "rgba(0,0,0,0.04)",
            border:
              todoFilter === f.key
                ? "none"
                : theme === "dark"
                ? "2px solid rgba(255,255,255,0.1)"
                : "2px solid rgba(0,0,0,0.08)",
            borderRadius: "12px",
            cursor: "pointer",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "4px",
            transform: todoFilter === f.key ? "translateY(-2px)" : "translateY(0)",
          }}
          onMouseEnter={(e) => {
            if (todoFilter !== f.key) {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.borderColor = "#2e7cba";
            }
          }}
          onMouseLeave={(e) => {
            if (todoFilter !== f.key) {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.borderColor =
                theme === "dark"
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.08)";
            }
          }}
        >
          <span>{f.label}</span>
          <span style={{ fontSize: 10, opacity: 0.8 }}>{f.count}</span>
        </button>
      ))}
    </div>
  );
};

export default TodoFilters;
